import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { hasAnyRole } from './roles';

/**
 * Route guard: renders `children` only if the user holds one of `required` roles,
 * otherwise redirects to the public access-denied page (no shell flash).
 *
 * Rendered only inside AuthGatedLayout, so by this point AuthGate has guaranteed the
 * user is loaded and signed in — `user.roles` is populated. This is UX only; the
 * backend require_role(...) is the real enforcement.
 */
export default function RoleRoute({
  required,
  children,
}: {
  required: readonly string[];
  children: React.ReactElement;
}): React.ReactElement {
  const { user } = useAuth();

  if (!hasAnyRole(user?.roles, required)) {
    return <Navigate to="/access-denied" replace />;
  }
  return children;
}
